module.exports = __webpack_public_path__ + "assets/img/zhongdong.971f671a.png";